import Restful from '../utils/restful.js'
const project = 'sci/'

const announcement = new Restful(project, 'announcement')
export default announcement
